export default {
    approveAddrList: '/wechatapp/placeNameAddress/firstApproveDepartment/listApproveDepartment', //communityId=1&communityType=4&def2=place_name
    delApprove:'/wechatapp/placeNameAddress/firstApproveDepartment/del', //id=
    addApprove:'/wechatapp/placeNameAddress/firstApproveDepartment/save', //firstApproveDepartment=1&communityId=1&communityType=4&def1=3&def2=place_name
    getSelect:'/wechatapp/placeNameAddress/firstApproveDepartment/listDepartment',

    historyAddrList: '/wechatapp/placeNameAddress/flow/historyAddress/list', //communityId=1&communityType=4&rows=0
    delHistory:'/wechatapp/placeNameAddress/flow/historyAddress/del' ,//id=
    addHistory:'/wechatapp/placeNameAddress/flow/historyAddress/save' //placeName=1233&communityId=1&communityType=4
}